module.exports = __webpack_public_path__ + "static/HIRING CONDITIONS BOTH ROOMS-d35606c94e6a8bc517c12435b1cd5c31.pdf";